
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Venetian Blinds | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Venetian Blinds</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/82.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB2/001</h3>
          </article>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/199.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB2/002</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/200.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB2/003</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/201.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB2/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/202.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB2/005</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/203.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB2/006</h3>
          </article>
      </div>
         </div>
    </section>
  )
}

export default Team